import { biggerPhone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledGrid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, 1fr);

  ${biggerPhone(css`
    grid-template-columns: 1fr;
  `)};
`
